import { useActivityBuilderPresentContext } from 'approot/activity-builder/present/activity-builder-present.context';
import { ViewProps } from 'approot/activity-builder/components/columns/columns.constants';
import * as Styled from 'approot/activity-builder/components/columns/columns.style';
import {
  getAppliedColour,
  isBackgroundApplied,
  isBorderApplied,
} from 'approot/activity-builder/components/columns/settings/column-settings.utils';
import { ComponentEventData } from 'approot/activity-builder/present/activity-builder-present-data-tracking.utils';
import StudentComponentsViewColumns from '../student-components-view-columns';

const StudentColumns = ({
  columns,
  columnProperties,
  contentId,
  eventTrackingData,
}: ViewProps & { eventTrackingData?: ComponentEventData }) => {
  const { isZoomToFit } = useActivityBuilderPresentContext();
  return (
    <Styled.ColumnsContainer
      $colours={getAppliedColour(columnProperties?.style)}
      $showBackground={isBackgroundApplied(columnProperties?.style)}
      $showBorder={isBorderApplied(columnProperties?.style)}
      $turnOffResponsive={isZoomToFit}
    >
      {columns?.map(column => (
        <Styled.ColumnsColumn
          key={column.columnId}
          $colspan={column.colspan}
          $alignment={column.alignment}
          $colours={getAppliedColour(column.style)}
          $showBorder={isBorderApplied(column.style)}
          $showBackground={isBackgroundApplied(column.style)}
          $turnOffResponsive={isZoomToFit}
        >
          <StudentComponentsViewColumns
            column={column}
            contentId={contentId}
            eventTrackingData={eventTrackingData}
          />
        </Styled.ColumnsColumn>
      ))}
    </Styled.ColumnsContainer>
  );
};

export default StudentColumns;
